<div [formGroup]="userFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
        <mat-label>{{ 'person.core.salutation' | translate }}</mat-label>
        <mat-select data-test="FS-Anrede" formControlName="salutation">
            <mat-option [value]="salutation.None"></mat-option>
            <mat-option [value]="salutation.Male">{{ 'person.core.salutationOptions.mr' | translate }}</mat-option>
            <mat-option [value]="salutation.Female">{{ 'person.core.salutationOptions.mrs' | translate }}</mat-option>
            <mat-option [value]="salutation.Divers">{{ 'person.core.salutationOptions.diverse' | translate }}</mat-option>
        </mat-select>
        <mat-error>{{userFormGroup.get('salutation').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <div fxFlex="50">&nbsp;</div>

    <mat-form-field appearance="fill" fxFlex="100" fxFlex.gt-xs="50" floatLabel="always">
        <mat-label>{{ 'person.core.firstName' | translate }}</mat-label>
        <input matInput data-test="FI-Vorname" type="text" formControlName="firstName">
        <mat-error>{{userFormGroup.get('firstName').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" fxFlex.gt-xs="50" floatLabel="always">
        <mat-label>{{ 'person.core.lastName' | translate }}</mat-label>
        <input matInput data-test="FI-Nachname" type="text" formControlName="lastName">
        <mat-error>{{userFormGroup.get('lastName').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'common.email' | translate }}</mat-label>
        <input matInput data-test="FI-E-Mail" type="text" formControlName="email">
        <mat-error>{{userFormGroup.get('email').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

</div>
